import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-grid"
}
const _hoisted_2 = {
  key: 0,
  class: "product-grid__caption"
}
const _hoisted_3 = { class: "product-grid__container" }
const _hoisted_4 = {
  key: 0,
  class: "product-grid__button tertiary-button product-grid__collapsed"
}
const _hoisted_5 = {
  key: 1,
  class: "product-grid__button clean-button product-grid__expanded"
}

import { onMounted, onBeforeUnmount, ref, computed } from 'vue';
  import useProductBlock from '@/composables/useProductBlock';
  import useWebsiteTexts from '@/composables/useWebsiteTexts';

  import ProductCard from '@/components/ProductCard';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductGrid',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

const props = __props

  const { websiteText } = useWebsiteTexts();

  

  const options = {
    setProducts,
    numProducts: props.block?.fields?.NumberOfProducts || 0,
  };

  const { registerProductBlock, unregisterProductBlock } = useProductBlock(options);

  const products = ref<any>([]);
  const isMobile = ref(false);
  const isExpanded = ref(false);

  const caption = computed(() => {
    return props.block?.fields?.Title;
  });

  const numberOfPreviewRows = computed(() => {
    return (
      (isMobile.value && props.block.fields?.NumberOfPreviewRowsForMobile
        ? props.block.fields?.NumberOfPreviewRowsForMobile
        : 0) ||
      (!isMobile.value && props.block.fields?.NumberOfPreviewRowsForDesktop
        ? props.block.fields?.NumberOfPreviewRowsForDesktop
        : 0)
    );
  });

  const numberOfProductsToDisplay = computed(() => {
    if (isMobile.value) {
      return 2 * props.block.fields.NumberOfPreviewRowsForMobile;
    }
    return 4 * props.block.fields.NumberOfPreviewRowsForDesktop;
  });

  const isExpandButtonVisible = computed(() => {
    return numberOfPreviewRows.value > 0 && numberOfProductsToDisplay.value < products.value.length;
  });

  const displayedProducts = computed(() => {
    if (numberOfPreviewRows.value == 0 || isExpanded.value || numberOfProductsToDisplay.value > products.value.length) {
      return products.value;
    }
    return products.value.slice(0, numberOfProductsToDisplay.value);
  });

  function toggleGridExpansion() {
    isExpanded.value = !isExpanded.value;
  }

  function updateScreenWidthState() {
    isMobile.value = window.innerWidth < 768;
  }

  onMounted(async () => {
    window.addEventListener('resize', updateScreenWidthState);
    updateScreenWidthState();

    await registerProductBlock(props.block);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidthState);
    unregisterProductBlock(props.block);
  });

  function setProducts(parentProducts: [any]) {
    products.value = parentProducts;
  }

return (_ctx: any,_cache: any) => {
  return (products.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(caption))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(caption)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_TransitionGroup, { name: "fade" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedProducts), (product) => {
                return (_openBlock(), _createBlock(_unref(ProductCard), {
                  key: product.articleNumber,
                  class: _normalizeClass(["product-grid__item", { 'product-grid__item--expandable': _unref(isExpandButtonVisible) }]),
                  product: product
                }, null, 8, ["class", "product"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "product-grid__expander",
          onClick: toggleGridExpansion
        }, [
          (_unref(isExpandButtonVisible) && !isExpanded.value)
            ? (_openBlock(), _createElementBlock("button", _hoisted_4, _toDisplayString(_unref(websiteText)('product_grid__expand').value), 1))
            : _createCommentVNode("", true),
          (_unref(isExpandButtonVisible) && isExpanded.value)
            ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(_unref(websiteText)('product_grid__collapse').value), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})